module.exports = __webpack_public_path__ + "img/Corp - Plano 24x - 01.1d808c91.png";